/**
 * ARES / ověření firmy v registraci
 *
 * - CZ: automatické dotažení firmy z IČO přes /jetedit/ares.php (vyplní firma, DIČ, adresu)
 * - SK: manuální zadání + statická validace formátu IČO/DIČ (bez RPO API, dle zadání)
 *
 * Progressive enhancement: aktivuje se jen když je na stránce pole IČO (jinde no-op),
 * takže je bezpečné spouštět globálně z main.js.
 *
 * TODO (potvrdit s Kateřinou — Trello):
 *  - přesné názvy polí v zalozky registračním formuláři (zde robustně přes víc selektorů),
 *  - SK formáty IČO/DIČ (zatím: IČO 8 číslic, DIČ 10 číslic, IČ DPH "SK"+10).
 */

// Pořadí: čistý root endpoint (dle generali, vyžaduje ares.php entrypoint v project.yaml),
// fallback na bind-mount cestu (funguje i bez entrypointu).
var ARES_ENDPOINTS = ['/ares.php', '/jetedit/ares.php'];

// Zkusí endpointy v pořadí, vrátí první validní ARES odpověď (stav === 'ok').
function aresFetch(ico, index) {
  index = index || 0;
  if (index >= ARES_ENDPOINTS.length) return Promise.reject(new Error('ARES nedostupný'));
  return fetch(ARES_ENDPOINTS[index] + '?ico=' + encodeURIComponent(ico), { headers: { 'Accept': 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
    .then(function (d) {
      if (d && (d.stav === 'ok' || d.firma)) return d;
      throw new Error('no data');
    })
    .catch(function () { return aresFetch(ico, index + 1); });
}

// Formáty (potvrdit). CZ i SK IČO = 8 číslic.
var ICO_RE = /^\d{8}$/;
var SK_DIC_RE = /^\d{10}$/;          // SK DIČ: 10 číslic
var SK_ICDPH_RE = /^SK\d{10}$/i;     // SK IČ DPH: SK + 10 číslic

// Najdi pole zkusmo přes id i name (REDA konvence se může lišit dle shopu).
function field(names) {
  for (var i = 0; i < names.length; i++) {
    var el = document.getElementById(names[i]) || document.querySelector('[name="' + names[i] + '"]');
    if (el) return el;
  }
  return null;
}

export function initAres() {
  var ico = field(['ico', 'odb_ico', 'registration_ico']);
  if (!ico) return; // žádné firemní/registrační pole na stránce

  var dic = field(['dic', 'odb_dic']);
  var staty = field(['id_staty', 'stat', 'staty']);

  // Detekce SK varianty: podle pole státu, jinak podle domény (cedok.reda.sk).
  function isSk() {
    if (staty && staty.value) return /sk/i.test(staty.value);
    return /\.sk(?:[:/]|$)/i.test(window.location.hostname);
  }

  function fillField(names, value, force) {
    if (value == null || value === '') return;
    var el = field(names);
    if (el && (force || !el.value)) el.value = value;
  }

  // Stavová hláška vedle IČO
  var status = document.createElement('span');
  status.className = 'ares-status';
  if (ico.parentNode) ico.parentNode.appendChild(status);
  function setStatus(msg, type) {
    status.textContent = msg || '';
    status.className = 'ares-status' + (type ? ' ares-status--' + type : '');
  }

  // --- CZ: ARES lookup ---
  function lookupCz() {
    var v = (ico.value || '').replace(/\s+/g, '');
    if (!ICO_RE.test(v)) { setStatus('IČO musí mít 8 číslic.', 'error'); return; }
    setStatus('Načítám z ARES…', 'loading');
    aresFetch(v)
      .then(function (d) {
        if (!d || (d.stav && d.stav !== 'ok')) { setStatus('Firma nebyla v ARES nalezena.', 'error'); return; }
        fillField(['firma', 'nazev_firmy', 'odb_firma'], d.firma);
        fillField(['dic', 'odb_dic'], d.dic);
        fillField(['ulice'], d.ulice);
        fillField(['mesto'], d.mesto);
        fillField(['psc'], d.psc != null ? String(d.psc) : '');
        setStatus('Načteno z ARES ✓', 'ok');
      })
      .catch(function () { setStatus('Chyba při dotazu na ARES.', 'error'); });
  }

  // --- SK: statická validace ---
  function validateSk() {
    var ok = true;
    var icoV = (ico.value || '').replace(/\s+/g, '');
    if (icoV && !ICO_RE.test(icoV)) {
      ico.setCustomValidity('Slovenské IČO musí mít 8 číslic.');
      setStatus('Slovenské IČO musí mít 8 číslic.', 'error');
      ok = false;
    } else {
      ico.setCustomValidity('');
    }
    if (dic && dic.value) {
      var dv = dic.value.replace(/\s+/g, '');
      if (!SK_DIC_RE.test(dv) && !SK_ICDPH_RE.test(dv)) {
        dic.setCustomValidity('Neplatný formát slovenského DIČ.');
        setStatus('Slovenské DIČ: 10 číslic (nebo IČ DPH „SK" + 10 číslic).', 'error');
        ok = false;
      } else {
        dic.setCustomValidity('');
      }
    }
    if (ok) setStatus('', '');
    return ok;
  }

  if (isSk()) {
    ico.addEventListener('blur', validateSk);
    if (dic) dic.addEventListener('blur', validateSk);
  } else {
    // Tlačítko „Načíst z ARES" vedle IČO
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--secondary btn--sm ares-btn';
    btn.textContent = 'Načíst z ARES';
    if (ico.parentNode) ico.parentNode.insertBefore(btn, status);
    btn.addEventListener('click', lookupCz);
    // Auto-lookup při opuštění pole, je-li platné IČO
    ico.addEventListener('blur', function () {
      if (ICO_RE.test((ico.value || '').replace(/\s+/g, ''))) lookupCz();
    });
  }
}
